/**
 * Pure visibility logic for the BrokerTokenGateModal.
 *
 * Kept framework-free so the decision can be unit-tested in isolation.
 * The modal must never render on the Broker Settings page (/broker), where
 * the user actually generates the session token — otherwise it covers the
 * very page they were sent to.
 */

export function isBrokerSettingsRoute(pathname) {
  const p = (pathname || '').replace(/\/+$/, '');
  return p === '/broker';
}

export function computeBrokerGate({ skipGate, status, tokenDismissed, mapDismissed, pathname }) {
  if (skipGate || !status) return { showGate: false, gateReason: null };
  if (isBrokerSettingsRoute(pathname)) return { showGate: false, gateReason: null };

  const tokenStatus = status.token_status || 'NO_BROKER';
  if (!status.has_active_broker) {
    return mapDismissed
      ? { showGate: false, gateReason: null }
      : { showGate: true, gateReason: 'no_broker' };
  }
  if ((tokenStatus === 'EXPIRED' || tokenStatus === 'NOT_SET') && !tokenDismissed) {
    return { showGate: true, gateReason: 'token_expired' };
  }
  return { showGate: false, gateReason: null };
}
